import React from "react";
import {ModalTitle} from "../../common/components/modules/modal/modalComponents";
import styled from "styled-components";
import {DeliveryModes} from "../../common/models/deliveryMode";

function DeliveryTypeBadge({deliveryType, deliveryMode, color}) {
  const Icon = deliveryType.icon;
  const deliveryModeLabel =
    deliveryMode && deliveryMode.code !== DeliveryModes.ASAP ? deliveryMode.name : "";
  return (
    <DeliveryTypeBadgeContainer color={color}>
      {Icon ? <Icon color={color} /> : null}
      <ModalTitle>
        {deliveryModeLabel ? `${deliveryModeLabel} ` : ""}
        {deliveryType.label}
      </ModalTitle>
    </DeliveryTypeBadgeContainer>
  );
}

const DeliveryTypeBadgeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  color: ${({color}) => color};
  border: 1px solid ${({theme, color}) => color || theme.v2.color.base.grey["900"]};
  border-radius: ${({theme}) => theme.v2.decoration.border.radius.default};
  padding: ${({theme}) => theme.v2.spacing(2)};
  margin: ${({theme}) => theme.v2.spacing(2)};
  > *:not(:last-child) {
    margin-right: ${({theme}) => theme.v2.spacing(2)};
  }
`;

export default DeliveryTypeBadge;
